import React from "react";
import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import "../src/app.css";
import Companies from "./components/Companies/Companies";
import Residencies from "./components/Residencies/Residencies";
import Contact from "./components/Contact/Contact";
import GetStarted from "./components/GetStarted/GetStarted";
import Footer from "./components/Footer/Footer";

const App = () => {
  return (
    <div className="App">
      <div>
        <dov className="white-gradient" />
        <Header />
        <Hero />
      </div>
      <Companies />
      <Contact />
      <GetStarted />
      <Footer />
    </div>
  );
};

export default App;
